import { FilterConfigType } from 'src/lib/types/filters'
import { extractDateFromFilters } from 'src/lib/utils/analyticsHelpers'
import { SSOAnalyticsTimeScale } from './common/types'
import { parseISO, differenceInHours } from 'date-fns'

export const AnalyticsfetchURL = '/dashboard/ssoAnalytics'
export const getOptimalTickCount = (width: number, minTickSpacing = 80) => {
  return Math.floor(width / minTickSpacing)
}

export type RequestBodyType = {
  widgetId: string
  timeRange: {
    start: string
    end: string
  }
  comparisonTimeRange?: {
    start: string
    end: string
  }
  timeScale?: SSOAnalyticsTimeScale
  filters?: {
    column: string
    operator: string
    value: string
  }[]
}

export const getRequestBody = ({
  merchantId,
  widgetId,
  filters,
  timeScale = 'daily'
}: {
  merchantId?: string
  widgetId: string
  filters: FilterConfigType
  timeScale?: SSOAnalyticsTimeScale
}) => {
  try {
    const body: RequestBodyType = {
      widgetId,
      timeRange: {
        start: extractDateFromFilters(filters, 'startDate', 'UTC'),
        end: extractDateFromFilters(filters, 'endDate', 'UTC')
      },
      // todo remove this once backend fixes the comparison time range
      // comparisonTimeRange: {
      //   start: extractDateFromFilters(filters, 'startDate', 'UTC'),
      //   end: extractDateFromFilters(filters, 'endDate', 'UTC')
      // },
      timeScale: timeScale ?? 'daily'
    }
    if (filters.comparison !== 'none') {
      const compStart = extractDateFromFilters(filters, 'compareToStartDate', 'UTC')
      const compEnd = extractDateFromFilters(filters, 'compareToEndDate', 'UTC')
      if (compStart !== body.timeRange.start || compEnd !== body.timeRange.end) {
        body.comparisonTimeRange = { start: compStart, end: compEnd }
      }
    }
    return body
  } catch (err) {
    console.error(err)
  }
}

export const getCurrentRange = (from: string, to: string) => {
  const start = parseISO(from)
  const end = parseISO(to)
  return { start, end }
}

export const isCurrentRangeWithin24h = (dateFilter: FilterConfigType) => {
  if (!dateFilter.startDate || !dateFilter.endDate) {
    return dateFilter.selectedStaticRange === 'today' || dateFilter.selectedStaticRange === 'yesterday'
  }
  const { start, end } = getCurrentRange(dateFilter.startDate, dateFilter.endDate)
  const diffInHours = Math.abs(differenceInHours(end, start))
  return diffInHours <= 24
}

export const isComparisonRangeWithin24h = (dateFilter: FilterConfigType) => {
  if (
    (dateFilter.selectedStaticRange === 'today' || dateFilter.selectedStaticRange === 'yesterday') &&
    dateFilter.comparison === 'previous'
  ) {
    return true
  }

  const startFrom = dateFilter.compareToStartDate ?? dateFilter.startDate
  const endFrom = dateFilter.compareToEndDate ?? dateFilter.endDate

  if (!startFrom || !endFrom) {
    return false
  }

  const { start, end } = getCurrentRange(startFrom, endFrom)

  const diffInHours = Math.abs(differenceInHours(end, start))
  return diffInHours <= 24
}
